import React from "react"
import { cn } from "@/lib/utils"

export type AppLocale = "cs" | "en" | "pl"

const LOCALES: AppLocale[] = ["cs", "en", "pl"]

interface LocaleTabsProps {
    value: AppLocale
    onChange: (locale: AppLocale) => void
}

export const LocaleTabs = ({ value, onChange }: LocaleTabsProps) => (
    <div className="flex gap-2">
        {LOCALES.map((loc) => (
            <button
                key={loc}
                type="button"
                onClick={() => onChange(loc)}
                className={cn(
                    "px-3 py-1.5 text-xs font-black rounded-xl transition-colors uppercase tracking-wide",
                    value === loc ? "bg-brand text-white" : "bg-slate-100 text-slate-500 hover:bg-slate-200",
                )}
            >
                {loc.toUpperCase()}
            </button>
        ))}
    </div>
)
